import React, { useState, useEffect, useRef, Fragment } from 'react';
import { Link, useLocation } from 'react-router-dom';
import API from '../api/axios';

const FALLBACK_MENUS = [
  { id: 1, parent_id: 0, sort_order: 1, title: 'Home', slug: 'home', url: '/', target: '_self' },
  { id: 2, parent_id: 0, sort_order: 2, title: 'About', slug: 'about', url: '/about', target: '_self' },
  { id: 22, parent_id: 2, sort_order: 1, title: 'About St Andrews Group', slug: 'about-group', url: '/about-group', target: '_self' },
  { id: 23, parent_id: 2, sort_order: 2, title: 'About Vasundhara Campus', slug: 'about', url: '/about', target: '_self' },
  { id: 24, parent_id: 2, sort_order: 3, title: 'Principal Message', slug: 'principal-message', url: '/principal-message', target: '_self' },
  { id: 25, parent_id: 2, sort_order: 4, title: 'Core Value', slug: 'core-values', url: '/core-values', target: '_self' },
  { id: 26, parent_id: 2, sort_order: 5, title: 'Awards & Recognition', slug: 'recognition', url: '/recognition', target: '_self' },
   { id: 51, parent_id: 2, sort_order: 6, title: 'Infrastructure', slug: 'infrastructure', url: '/infrastructure', target: '_self' },

  { id: 3, parent_id: 0, sort_order: 3, title: 'Academics', slug: 'academics', url: '/academics', target: '_self' },
  { id: 307, parent_id: 3, sort_order: 1, title: 'Curriculum', slug: 'curriculum', url: '/curriculum', target: '_self' },
  { id: 308, parent_id: 3, sort_order: 2, title: 'Our Programme', slug: 'our-programmes', url: '/our-programmes', target: '_self' },
  { id: 313, parent_id: 308, sort_order: 1, title: 'Foundational Programme', slug: 'foundational-programme', url: '/foundational-programme', target: '_self' },
  { id: 314, parent_id: 308, sort_order: 2, title: 'Preparatory Programme', slug: 'preparatory-programme', url: '/preparatory-programme', target: '_self' },
  { id: 315, parent_id: 308, sort_order: 3, title: 'Middle Programme', slug: 'middle-school-programme', url: '/middle-school-programme', target: '_self' },
  { id: 4, parent_id: 0, sort_order: 4, title: 'Admission', slug: 'admission', url: '/admission', target: '_self' },
  { id: 41, parent_id: 4, sort_order: 1, title: 'Admission Guidelines', slug: 'admission-guidelines', url: '/admission-guidelines', target: '_self' },
  { id: 43, parent_id: 4, sort_order: 3, title: 'Fee Structure', slug: 'fees', url: '/fees', target: '_self' },
  { id: 5, parent_id: 0, sort_order: 5, title: 'Student Life', slug: 'student-life', url: '#', target: '_self' },
  { id: 52, parent_id: 5, sort_order: 2, title: 'Beyond Classroom', slug: 'beyond-classroom', url: '/beyond-classroom', target: '_self' },
  { id: 53, parent_id: 5, sort_order: 3, title: 'Other Facilities', slug: 'other-facilities', url: '/other-facilities', target: '_self' },
  { id: 54, parent_id: 5, sort_order: 4, title: 'Extra Curriculum Activities', slug: 'extra-curricular-activities', url: '/extra-curricular-activities', target: '_self' },
  { id: 6, parent_id: 0, sort_order: 6, title: 'Gallery', slug: 'gallery', url: '/gallery', target: '_self' },
  { id: 7, parent_id: 0, sort_order: 7, title: 'Blog', slug: 'blog', url: '/blog', target: '_self' },
  { id: 9, parent_id: 0, sort_order: 8, title: 'Contact', slug: 'contact', url: '/contact', target: '_self' },
];

const SCHOOLS = [
  { name: 'Gurugram', url: 'https://www.sawsgurugram.com/' },
  { name: 'Indirapuram', url: 'https://www.sawsindirapuram.com/' },
  { name: 'Dehradun', url: 'https://www.sawsdehradun.in/' },
  { name: 'Siddharth Vihar', url: 'https://sawssiddharthvihar.in/' },
  { name: 'Sonipat', url: 'https://www.sawssonipat.com/' },
];

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [menus, setMenus] = useState([]);
  const [openSubMenus, setOpenSubMenus] = useState({});

  const [settings, setSettings] = useState({});
  const [isMobile, setIsMobile] = useState(false);
  const [schoolOpen, setSchoolOpen] = useState(false);
  const schoolRef = useRef(null);
  const location = useLocation();

  useEffect(() => {
    const mq = window.matchMedia('(max-width: 1023px)');
    setIsMobile(mq.matches);
    const handler = (e) => setIsMobile(e.matches);
    mq.addEventListener('change', handler);
    return () => mq.removeEventListener('change', handler);
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const menuRes = await API.get('/menus/public').catch(() => null);
        if (menuRes?.data?.data && menuRes.data.data.length > 0) {
          setMenus(menuRes.data.data);
        }
        const [settingRes, contactRes] = await Promise.all([
          API.get('/settings/public'),
          API.get('/contacts/public'),
        ]);
        const s = settingRes.data.data || {};
        const c = contactRes.data.data || {};
        setSettings({ ...s, ...c });
      } catch (err) { console.error(err); }
    };
    fetchData();
  }, []);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (schoolRef.current && !schoolRef.current.contains(e.target)) setSchoolOpen(false);
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  useEffect(() => {
    if (!menuOpen) setOpenSubMenus({});
  }, [menuOpen]);

  useEffect(() => {
    setOpenSubMenus({});
  }, [location.pathname]);

  const isActive = (slug) => {
    const path = location.pathname;
    if (slug === 'home' && path === '/') return true;
    return path === `/${slug}` || path.startsWith(`/${slug}/`);
  };

  const effectiveMenus = menus.length > 0 ? menus : FALLBACK_MENUS;
  const topMenus = effectiveMenus.filter(m => m.parent_id === 0).sort((a, b) => a.sort_order - b.sort_order);

  const getChildren = (parentId) =>
    effectiveMenus.filter(m => m.parent_id === parentId).sort((a, b) => a.sort_order - b.sort_order);

  const toggleSubMenu = (id, force) => {
    setOpenSubMenus(prev => ({ ...prev, [id]: force !== undefined ? force : !prev[id] }));
  };

  const renderMenu = (items, depth = 0, parentId = null) => (
    <ul className={
      depth === 0
        ? 'flex flex-col lg:flex-row lg:items-center lg:justify-center'
        : depth === 1
          ? 'lg:absolute lg:left-0 lg:top-full bg-[#1b3160] shadow-lg z-50 lg:min-w-[220px] w-full py-1 sub-menu' +
            (depth > 0 && parentId && openSubMenus[parentId] ? ' open' : '')
          : 'lg:absolute lg:left-full lg:top-0 bg-[#1b3160] shadow-lg z-50 lg:min-w-[220px] w-full py-1 sub-menu' +
            (depth > 0 && parentId && openSubMenus[parentId] ? ' open' : '')
    }
    >
      {items.map(menu => {
        const children = getChildren(menu.id);
        const hasChildren = children.length > 0;
        return (
          <li key={menu.id} className="relative"
            onMouseEnter={() => { if (hasChildren) toggleSubMenu(menu.id, true); }}
            onMouseLeave={() => { if (hasChildren) toggleSubMenu(menu.id, false); }}
          >
            <div className="flex items-center justify-between">
              <Link to={menu.url}
                    className={`flex-1 block px-4 py-3 text-white text-[15px] capitalize font-semibold hover:bg-white/10 transition-colors ${isActive(menu.slug) ? 'bg-white/10' : ''}`}
                    onClick={() => { if (!hasChildren) setMenuOpen(false); }}
                    target={menu.target}>
                {menu.title}
              </Link>
              {hasChildren && (

                <button
                  onClick={(e) => { e.preventDefault(); toggleSubMenu(menu.id); }}
                  className={`px-3 py-2.5 text-white/60 hover:text-white hover:bg-white/10 transition-colors text-[15px] lg:hidden`}
                  aria-label="Toggle Submenu"
                >
                  <i className={`fas fa-chevron-${openSubMenus[menu.id] ? 'up' : 'down'}`}></i>
                </button>
              )}
            </div>
            {hasChildren && renderMenu(children, depth + 1, menu.id)}
          </li>
        );
      })}
    </ul>
  );

  return (
    <>
      {/* Top Bar */}
      <div className="bg-[#1b3160] text-white/80 py-2 text-[12px] sm:text-[13px] relative z-[60]">
        <div className="container max-w-full flex items-center justify-between px-2 md:px-8">
          
          {/* Left: Contact Icons */}
          <div className="flex items-center gap-3 md:gap-6">
            <div className="flex items-center gap-2">
              <a href="tel:+919311221083" className="hover:text-white transition-colors">
                <i className="fas fa-phone"></i>
              </a>
              <div className="hidden md:flex items-center gap-1">
                {settings.phone ? (
                  settings.phone.split(/[,|]/).map((phone, i) => (
                    <React.Fragment key={i}>
                      <a href={`tel:+91${phone.trim()}`} className="hover:text-white transition-colors">
                        +91-{phone.trim()}
                      </a>
                      {i < (settings.phone.split(/[,|]/).length - 1) && <span className="text-white/50">|</span>}
                    </React.Fragment>
                  ))
                ) : (
                  <>
                    <a href="tel:+919311221083" className="hover:text-white transition-colors">+91-9311221083</a>
                    <span className="text-white/50">|</span>
                    <a href="tel:+919311221084" className="hover:text-white transition-colors">+91-9311221084</a>
                  </>
                )}
              </div>
            </div>
            
            <div className="hidden md:block text-white/50">|</div>
            
            <div className="flex items-center gap-2">
              <a href={`mailto:${settings.email || 'info@sawsvasundhara.com'}`} className="hover:text-white transition-colors">
                <i className="fas fa-envelope"></i>
              </a>
              <a href={`mailto:${settings.email || 'info@sawsvasundhara.com'}`} className="hidden md:block hover:text-white transition-colors">
                { (settings.email || 'info@sawsvasundhara.com | info@sawsvasundhara.com').replace(/,/g, ' | ') }
              </a>
            </div>
          </div>
          
          {/* Right: Socials, Schools */}
          <div className="flex items-center gap-3 md:gap-4">
            <a href={settings.facebook || '#'} target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors"><i className="fab fa-facebook-f"></i></a>
            <a href={settings.instagram || '#'} target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors"><i className="fab fa-instagram"></i></a>
            <a href={settings.youtube || '#'} target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors"><i className="fab fa-youtube"></i></a>
            
            
            <div className="relative ml-1 md:ml-2" ref={schoolRef}>
              <button onClick={() => setSchoolOpen(!schoolOpen)} className="flex items-center gap-1 hover:text-white focus:outline-none transition-colors">
                Our Schools <i className={`fas fa-chevron-${schoolOpen ? 'up' : 'down'} text-[10px]`}></i>
              </button>
              {schoolOpen && (
                <div className="absolute top-full right-0 mt-2 w-48 sm:w-56 bg-white rounded shadow-xl border border-gray-100 py-2 overflow-hidden z-50 text-gray-800">
                  {SCHOOLS.map(s => (
                    <a key={s.name} href={s.url} target="_blank" rel="noopener noreferrer" className="block px-4 py-2 hover:bg-gray-50 transition-colors">
                      {s.name}
                    </a>
                  ))}
                </div>
              )}
            </div>
          </div>
          
        </div>
      </div>

      {/* Main Header */}
      <header className="bg-white sticky top-0 z-50 shadow-sm transition-all duration-300">
        <div className="container max-w-full px-4 md:px-8 py-2 md:py-3">
          <div className="flex items-center justify-between">
            
            {/* Logo */}
            <div className="flex-shrink-0 flex items-center gap-3 md:gap-4">
              <Link to="/" className="relative group" onClick={() => setMenuOpen(false)}>
                <img src={settings.logo ? `${settings.logo}` : '/frontend/images/andrews-logo-1.png'} alt="St. Andrews World School" className="h-12 md:h-[4.5rem] w-auto object-contain transition-transform duration-300 group-hover:scale-105" />
              </Link>
              <span className="hidden sm:block w-px h-10 md:h-14 bg-gray-300"></span>
              <img src="/frontend/images/cambridge-logo.png" alt="Cambridge Assessment" className="hidden md:block h-8 md:h-14 object-contain" onError={(e) => e.target.style.display = 'none'} />
            </div>

            {/* Buttons (Right) */}
            <div className="hidden lg:flex items-center gap-4 ml-auto">
              <Link to="/admission" className="px-6 py-2 bg-[#1b3160] text-white rounded-full font-semibold text-[15px] hover:bg-opacity-90 transition flex items-center gap-2">
                Apply Now <i className="fas fa-arrow-right text-[13px]"></i>
              </Link>
              <button onClick={(e) => { e.preventDefault(); window.dispatchEvent(new Event('open-campus-video')); }} className="px-6 py-2 border border-[#1b3160] text-[#1b3160] bg-white rounded-full font-semibold text-[15px] hover:bg-gray-50 transition">
                Our Campus Tour
              </button>
            </div>

            <button className="lg:hidden bg-[#1b3160] text-white px-4 py-2 rounded-md focus:outline-none" onClick={() => setMenuOpen(!menuOpen)} aria-label="Toggle Menu">
              <i className={`fas ${menuOpen ? 'fa-times' : 'fa-bars'}`}></i>
            </button>
          </div>
        </div>
      </header>

      {/* Navigation */}
      <div className={`bg-[#1b3160] sticky top-[60px] md:top-[80px] z-40 ${menuOpen ? 'block' : 'hidden'} lg:block border-b border-white/10`}>
        <div className="container max-w-full flex justify-center">
          <nav className="relative main-nav">
            {renderMenu(topMenus)}
          </nav>
        </div>
      </div>

      {menuOpen && <div className="fixed inset-0 bg-black/40 z-30" onClick={() => setMenuOpen(false)} />}
    </>
  );
};

export default Header;
